// extracted by mini-css-extract-plugin
export var avatarContainer = "_b3-0";
export var avatarTypingWave = "_b3-i";
export var gray = "_b3-f";
export var green = "_b3-c";
export var icon = "_b3-9";
export var image = "_b3-1";
export var lg = "_b3-6";
export var md = "_b3-5";
export var presenceDot = "_b3-b";
export var red = "_b3-d";
export var sm = "_b3-4";
export var status = "_b3-a";
export var typingDot = "_b3-h";
export var typingPill = "_b3-g";
export var xl = "_b3-7";
export var xs = "_b3-3";
export var xxl = "_b3-8";
export var xxs = "_b3-2";
export var yellow = "_b3-e";